import './App.css'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { connect } from './Redux/Blockchain/blockchainActions'
import { fetchData } from './Redux/Data/dataActions'
import styled from 'styled-components'
import Logo from './Images/logo.png'
import TokenBg from './Images/token_bg.png'
import Header from './Header'
import About from './Images/about_img2.png'
import Bgimg from './Images/banner_img2.png'
import Service1 from './Images/Asset2.svg'
import Service2 from './Images/Asset4.svg'
import Service3 from './Images/Asset1.svg'
import team1 from './Images/team1.jpeg'
import team2 from './Images/2team.jpeg'
import team3 from './Images/3team.jpeg'
import team4 from './Images/team4.jpeg'

function App() {
  const calculateTimeLeft = () => {
    let year = new Date().getFullYear();
    const difference = +new Date('12/30/2021') - +new Date();
    let timeLeft = {};
    if (difference > 0) {
        timeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        };
      }
      return timeLeft;
};
  const dispatch = useDispatch()
  const blockchain = useSelector((state) => state.blockchain)
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [year] = useState(new Date().getFullYear());
  const data = useSelector((state) => state.data)
  const [claimingNft, setClaimingNft] = useState(false)
  const [feedback, setFeedback] = useState(`Click mint to mint your NFT.`)
  const [mintAmount, setMintAmount] = useState(1)
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: '',
    SCAN_LINK: '',
    NETWORK: {
      NAME: '',
      SYMBOL: '',
      ID: 0,
    },
    NFT_NAME: '',
    SYMBOL: '',
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: '',
    MARKETPLACE_LINK: '',
    SHOW_BACKGROUND: false,
  })

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST
    let gasLimit = CONFIG.GAS_LIMIT
    let totalCostWei = String(cost * mintAmount)
    let totalGasLimit = String(gasLimit * mintAmount)
    console.log('Cost: ', totalCostWei)
    console.log('Gas limit: ', totalGasLimit)
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`)
    setClaimingNft(true)
    const to = blockchain.account
    blockchain.smartContract.methods
      .Presalemint(to, mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0.155 * 10 ** 18 * mintAmount,
      })
      .once('error', (err) => {
        console.log(err)
        setFeedback('Sorry, something went wrong please try again later.')
        setClaimingNft(false)
      })
      .then((receipt) => {
        console.log(receipt)
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`,
        )
        setClaimingNft(false)
        dispatch(fetchData(blockchain.account))
      })
  }

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1
    if (newMintAmount < 1) {
      newMintAmount = 1
    }
    setMintAmount(newMintAmount)
  }

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1
    if (newMintAmount > 10) {
      newMintAmount = 10
    }
    setMintAmount(newMintAmount)
  }

  const getData = () => {
    if (blockchain.account !== '' && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account))
    }
  }

  const getConfig = async () => {
    const configResponse = await fetch('/config/config.json', {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    const config = await configResponse.json()
    SET_CONFIG(config)
  }

  useEffect(() => {
    getConfig()
  }, [])

  useEffect(() => {
    getData()
  }, [blockchain.account])
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });
  const timerComponents = [];
  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }
  
    timerComponents.push(
      <span>
        {timeLeft[interval]} {interval}{" "}
      </span>
    );
  });
  return (
    <div className="HomePage">
      <div
        className="parallax-mirror"
        style={{
          visibility: 'hidden',
          zIndex: 1,
          position: 'fixed',
          top: '0px',
          left: '0px',
          overflow: 'hidden',
          height: '417px',
          width: '1349px',
        }}
      >
        <img
          class="parallax-slider"
          src={TokenBg}
          style={{
            position: 'absolute',
            left: '0px',
            height: '1062px',
            width: '1349px',
            maxWidth: 'none',
          }}
        />
      </div>
      <div
        className="parallax-mirror"
        style={{
          visibility: 'visible',
          zIndex: 1,
          position: 'fixed',
          top: '-59.0312px',
          left: '0px',
          overflow: 'hidden',
          height: '758px',
          width: '1349px',
        }}
      >
        <img
          class="parallax-slider"
          src={TokenBg}
          style={{
            position: 'absolute',
            left: '0px',
            height: '1292px',
            width: '1349px',
            maxWidth: 'none',
            top: '-259.775px',
          }}
        />
      </div>
      <Header />

      <section id="home_section" className="section_banner bg_black_dark">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12 order-lg-first">
              <div className="banner_text_s2 text_md_center">
                <h1
                  className="animation text-white animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="1.1s"
                  style={{ animationDelay: '1.1s', opacity: 1 }}
                >
                  <strong>COIN ON FILE TOKEN </strong>

                  <strong> ($COFT)</strong>
                </h1>
                <h5>
                  {' '}
                  We are launching COFT, Coin On File Token to provide you the
                  best OTT platform, Gaming Platform & E-Commerce Platform which
                  will offers you a very unique, interactive & profitable
                  solution. Our token will be used on many ecommerce platforms
                  that are already on the Internet & you will get huge discounts
                  & offers when we shop using COFT.
                </h5>
                <h5
                  className="animation presale_txt text-white animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="1.3s"
                  style={{ animationDelay: '1.3s', opacity: 1 }}
                >
                  <br />
                  Token Public sales is <mark class="gradient_box">Live</mark>
                </h5>
                <br />
                <div
                  className="btn_group pt-2 pb-3 animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="1.4s"
                  style={{ animationDelay: '1.4s', opacity: 1 }}
                >
                  <a
                    href="/COFTOKENWHITEPAPER.pdf"
                    className="btn btn-default btn-radius nav-link content-popup"
                  >
                    Whitepaper <i className="ion-ios-arrow-thin-right"></i>
                  </a>
                  <a href="#token" className="btn btn-border btn-radius">
                    Buy Token Now! <i className="ion-ios-arrow-thin-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 order-first">
              <div
                className="banner_image_right res_md_mb_50 res_xs_mb_30 animation animated fadeInRight"
                data-animation-delay="1.5s"
                data-animation="fadeInRight"
                style={{ animationDelay: '1.5s', opacity: 1 }}
              >
                <img alt="banner_vector2" src={Logo} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="service" className="small_pb small_pt">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 offset-lg-2 col-md-12 col-sm-12">
              <div className="title_default_light title_border text-center">
                <h4
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.2s"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                >
                  Meet our solution for you
                </h4>
                <p
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.4s"
                  style={{ animationDelay: '0.4s', opacity: 1 }}
                >
                  Our solution is very simple – provide a way to reward users
                  for being the backbone of OTT, gaming, and ecommerce success.
                  The Coin On File Token provides a way to solve problem 1 by
                  banking on blockchain as a solution to provide access to
                  revenue for users through the COFT token
                </p>
              </div>
            </div>
          </div>
          <div className="row title_default_light ">
            <div className="col-lg-4 col-md-6 col-sm-12 ">
              <div
                className="box_wrap text-center animation animated fadeInUp"
                data-animation="fadeInUp"
                data-animation-delay="0.6s"
                style={{ animationDelay: '0.6s', opacity: 1 }}
              >
                <img
                  src={Service1}
                  alt="service_icon1"
                  width={110}
                  height={67}
                />
                <h4>Banking on Blockchain</h4>
                <p>
                  The Coin On File Token provides a way to solve problem 1 by
                  banking on blockchain as a solution to provide access to
                  revenue for users through the COFT token.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div
                className="box_wrap text-center animation animated fadeInUp"
                data-animation="fadeInUp"
                data-animation-delay="0.8s"
                style={{ animationDelay: '0.6s', opacity: 1 }}
              >
                <img
                  src={Service2}
                  alt="service_icon2"
                  width={110}
                  height={67}
                />
                <h4>Community driven.</h4>
                <p>
                  Problem 2 is solved by creating a vibrant and user-centric
                  community where everyone determines what happens within the
                  ecosystem.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div
                className="box_wrap text-center animation animated fadeInUp"
                data-animation="fadeInUp"
                data-animation-delay="1s"
                style={{ animationDelay: '1s', opacity: 1 }}
              >
                <img
                  src={Service3}
                  alt="service_icon3"
                  width={110}
                  height={67}
                />
                <h4>Auto Claim Rewards</h4>
                <p>
                  For the first time ever, you don’t need to claim your earned
                  tokens. It’s automatically sent to your wallet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="about" className="small_pt">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text_md_center">
                <img
                  className="animation animated zoomIn"
                  data-animation="zoomIn"
                  data-animation-delay="0.2s"
                  src={About}
                  alt="aboutimg2"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 res_md_mt_30 res_sm_mt_20">
              <div className="title_default_light title_border">
                <h4
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.2s"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                >
                  About COFT
                </h4>
                <p
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.4s"
                  style={{ animationDelay: '0.4s', opacity: 1 }}
                >
                  Coin On File Token (COFT) is an innovation that is
                  blockchain-based for the OTT industry, the Gaming industry,
                  and the E-commerce industry. It brings to the very forefront
                  unique, interactive, and profitable solutions to these
                  industries by providing a truly transparent and decentralized
                  system to enjoy the true benefits of both cryptocurrency and
                  these industries. The COFT token would be used on different
                  e-commerce platforms that are already on the internet and will
                  give users access to huge discounts and offers when shopping
                  with COFT. We believe in transparency and accuracy, that’s why
                  everything we do is crystal clear with COFT.{' '}
                </p>
                <p
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.8s"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                >
                  COFT is implementing blockchain to reengineer OTT, e-commerce,
                  and the gaming industry. We are building a user-centric token
                  that can be used on video streaming platforms (OTTs),
                  ecommerce platforms, and gaming platforms while receiving
                  rewards using the token – Coin on File.{' '}
                </p>
              </div>
              <a
                href="#"
                className="btn btn-default btn-radius video animation animated fadeInUp"
                data-animation="fadeInUp"
                data-animation-delay="1s"
                style={{ animationDelay: '1s', opacity: 1 }}
              >
                Learn More <i className="ion-ios-arrow-thin-right"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section
        id="token"
        className="section_token token_sale bg_light_dark"
        data-z-index="1"
        data-parallax="scroll"
        data-image-src="./Images/token_bg.png"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12">
              <div className="title_default_light title_border text-center">
                <h4
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.2s"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                >
                  Token Sale
                </h4>
                <p
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.4s"
                  style={{ animationDelay: '0.4s', opacity: 1 }}
                >
                  Token Public sale is now live. Be the first to buy in Early
                  and enjoy the benfits.
                </p>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-3"></div>
            <div className="col-lg-6">
              <div className="token_sale res_md_mb_40 res_md_mt_40 res_sm_mb_30 res_sm_mt_30">
                <div
                  className="tk_countdown text-center animation token_countdown_bg animated fadeIn"
                  data-animation="fadeIn"
                  data-animation-delay="1s"
                  style={{ animationDelay: '1s', opacity: 1 }}
                >
                  <div className="tk_counter_inner">
                    <div
                      className="tk_countdown_time animation animated fadeInUp"
                      data-animation="fadeInUp"
                      data-animation-delay="1.2s"
                      data-time="2021/12/25 00:00:00"
                      style={{ animationDelay: '1.2s', opacity: 1, color: '#fff' }}
                    >Time Remaining<br/>
                      {timerComponents.length ? timerComponents : <span>Time is done</span>}
                    </div>
                    <br />
                    <form>
                      <input
                        placeholder="Enter Amount You Wish to Purchase"
                        type="number"
                        name="Amount"
                        field="Amount"
                      />{' '}
                      <br /> <br />
                      <input
                        placeholder="Enter Referral Address(optional)"
                        name="Referral"
                        field="Referral"
                      />
                    </form>
                    <h9
                      style={{
                        textAlign: 'left',
                        color: 'orange',
                      }}
                    >
                      {' '}
                      &zwnj;
                      {blockchain.errorMsg}
                    </h9>
                    <a
                      className="btn btn-default btn-radius animation animated fadeInUp"
                      data-animation="fadeInUp"
                      data-animation-delay="1.4s"
                      style={{ animationDelay: '1.4s', opacity: 1 }}
                    >
                      {blockchain.account === '' ||
                      blockchain.smartContract === null ? (
                        <div
                          onClick={(e) => {
                            e.preventDefault()
                            dispatch(connect())
                            getData()
                          }}
                        >
                          {' '}
                          Connect Wallet{' '}
                        </div>
                      ) : (
                        <div>
                          Buy Tokens{' '}
                          <i className="ion-ios-arrow-thin-right"></i>
                        </div>
                      )}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3"></div>
          </div>
        </div>
      </section>
      <section id="roadmap" className="section_team">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12 offset-lg-2">
              <div className="title_default_light title_border text-center">
                <h4
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.2s"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                >
                  OUR ROADMAP
                </h4>
                <p
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.4s"
                  style={{ animationDelay: '0.4s', opacity: 1 }}
                >
                  The use of cryptocurrencies has become more widespread, The
                  origin platform idea. Development of the concept and business
                  plan.
                </p>
              </div>
            </div>
          </div>
          <div>
            <div className="row">
              <div className="col-md-12">
                <div class="timeline owl-carousel small_space owl-loaded owl-drag">
                  <div
                    className="owl-stage-outer owl-height"
                    style={{ height: '144px' }}
                  >
                    <div
                      className="owl-stage"
                      style={{
                        transform: 'translate3d(-468px, 0px, 0px)',
                        transition: 'all 0.25s ease 0s',
                        width: '1638px',
                      }}
                    >
                      <div
                        className="owl-item"
                        style={{ width: '204px', marginRight: '30px' }}
                      >
                        <div className="item">
                          <div className="timeline_box complete">
                            <div className="timeline_inner">
                              <div className="timeline_circle"></div>
                              <h6
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.3s"
                                style={{ animationDelay: '0.3s', opacity: 1 }}
                              >
                                October 2021
                              </h6>
                              <p
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.4s"
                                style={{ animationDelay: '0.4s', opacity: 1 }}
                              >
                                Inotial Coin Distribution &amp; maketing
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="owl-item"
                        style={{ width: '204px', marginRight: '30px' }}
                      >
                        <div className="item">
                          <div className="timeline_box complete current">
                            <div className="timeline_inner">
                              <div className="timeline_circle"></div>
                              <h6
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.3s"
                                style={{ animationDelay: '0.3s', opacity: 1 }}
                              >
                                December 2021
                              </h6>
                              <p
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.4s"
                                style={{ animationDelay: '0.4s', opacity: 1 }}
                              >
                                Platform Launched, Presale & Crowdfunding
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="owl-item active"
                        style={{ width: '204px', marginRight: '30px' }}
                      >
                        <div className="item">
                          <div className="timeline_box">
                            <div className="timeline_inner">
                              <div className="timeline_circle"></div>
                              <h6
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.3s"
                                style={{ animationDelay: '0.3s', opacity: 1 }}
                              >
                                December 2021
                              </h6>
                              <p
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.4s"
                                style={{ animationDelay: '0.4s', opacity: 1 }}
                              >
                               Platform Launched, Presale & Crowdfunding
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="owl-item active"
                        style={{ width: '204px', marginRight: '30px' }}
                      >
                        <div className="item">
                          <div className="timeline_box">
                            <div className="timeline_inner">
                              <div className="timeline_circle"></div>
                              <h6
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.3s"
                                style={{ animationDelay: '0.3s', opacity: 1 }}
                              >
                               January 2022
                              </h6>
                              <p
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.4s"
                                style={{ animationDelay: '0.3s', opacity: 1 }}
                              >
                               Listing on Exchange
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="owl-item active"
                        style={{ width: '204px', marginRight: '30px' }}
                      >
                        <div className="item">
                          <div className="timeline_box">
                            <div className="roadmap_inner">
                              <div className="timeline_circle"></div>
                              <h6
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.3s"
                                style={{ animationDelay: '0.3s', opacity: 1 }}
                              >
                                February 2022
                              </h6>
                              <p
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.4s"
                                style={{ animationDelay: '0.4s', opacity: 1 }}
                              >
                              Launch of OTT Platform
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="owl-item active"
                        style={{ animationDelay: '0.3s', opacity: 1 }}
                      >
                        <div className="item">
                          <div className="timeline_box">
                            <div className="timeline_inner">
                              <div className="timeline_circle"></div>
                              <h6
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.3s"
                                style={{ animationDelay: '0.3s', opacity: 1 }}
                              >
                                March 2022
                              </h6>
                              <p
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.4s"
                                style={{ animationDelay: '0.4s', opacity: 1 }}
                              >
                                Gaming Platform
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="owl-item active"
                        style={{ width: '204px', marginRight: '30px' }}
                      >
                        <div className="item">
                          <div className="timeline_box">
                            <div className="timeline_inner">
                              <div className="timeline_circle"></div>
                              <h6
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.3s"
                                style={{ animationDelay: '0.3s', opacity: 1 }}
                              >
                                April 2022
                              </h6>
                              <p
                                className="animation animated fadeInUp"
                                data-animation="fadeInUp"
                                data-animation-delay="0.4s"
                                style={{ animationDelay: '0.4s', opacity: 1 }}
                              >
                                Listing on All Other Exchanges
                              </p>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  <div className="owl-nav">
                    <div className="owl-prev disabled">
                      <i className="ion-ios-arrow-back"></i>
                    </div>
                    <div className="owl-next">
                      <i className="ion-ios-arrow-forward"></i>
                    </div>
                  </div>
                  <div className="owl-dots">
                    <div className="owl-dot active">
                      <span></span>
                    </div>
                    <div className="owl-dot">
                      <span></span>
                    </div>
                  </div>

                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="team" className="section_team small_pt">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12 offset-lg-2">
              <div className="title_default_light title_border text-center">
                <h4
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.2s"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                >
                  Leadership Team
                </h4>
                <p
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.4s"
                  style={{ animationDelay: '0.4s', opacity: 1 }}
                >
                  we are proud of our great team. He is one of the most
                  motivated and enthusiastic people we have, and is always ready
                  and willing to help out where needed.{' '}
                </p>
              </div>
            </div>
          </div>
          <div className="row small_space">
            <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
              <div
                className="bg_light_dark radius_box team_box_s3 animation animated fadeInUp"
                data-animation="fadeInUp"
                data-animation-delay="0.4s"
                style={{ animationDelay: '0.4s', opacity: 1 }}
              >
                <div className="text-center">
                  <img src={team4} alt="team1" height={148} width={225} />
                </div>
                <div className="team_info text-center">
                  <h4>
                    <a
                      href="#team1"
                      className="content-popup"
                      style={{ color: 'white' }}
                    >
                      Mark Hill
                    </a>
                  </h4>
                  <p style={{ color: 'white' }}>CHIEF EXECUTIVE OFFICER</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
              <div
                className="bg_light_dark radius_box team_box_s3 animation animated fadeInUp"
                data-animation="fadeInUp"
                data-animation-delay="0.6s"
                style={{ animationDelay: '0.6s', opacity: 1 }}
              >
                <div className="text-center">
                  <img src={team3} alt="team2" />
                </div>
                <div className="team_info text-center">
                  <h4>
                    <a
                      href="#team2"
                      className="content-popup"
                      style={{ color: 'white' }}
                    >
                      Shawn Warner
                    </a>
                  </h4>
                  <p style={{ color: 'white' }}>VP operations</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
              <div
                className="bg_light_dark radius_box team_box_s3 animation animated fadeInUp"
                data-animation="fadeInUp"
                data-animation-delay="0.8s"
                style={{ animationDelay: '0.8s', opacity: 1 }}
              >
                <div className="text-center">
                  <img src={team2} alt="team3" />
                </div>
                <div className="team_info text-center">
                  <h4>
                    <a
                      href="#team3"
                      className="content-popup"
                      style={{ color: 'white' }}
                    >
                      David Lee
                    </a>
                  </h4>
                  <p style={{ color: 'white' }}>Global Head of Products</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div
                className="bg_light_dark radius_box team_box_s3 animation animated fadeInUp"
                data-animation="fadeInUp"
                data-animation-delay="1s"
                style={{ animationDelay: '1s', opacity: 1 }}
              >
                <div className="text-center">
                  <img src={team1} alt="team4" />
                </div>
                <div className="team_info text-center">
                  <h4>
                    <a
                      href="#team4"
                      className="content-popup"
                      style={{ color: 'white' }}
                    >
                      Aman Soni
                    </a>
                  </h4>
                  <p style={{ color: 'white' }}>Director of Content</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" className="contact_section small_pt">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12 offset-lg-2">
              <div className="title_default_light title_border text-center">
                <h4
                  className="animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.2s"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                >
                  Get In Touch!
                </h4>
              </div>
            </div>
          </div>
          <div className="row align-items-center small_space">
            <div className="col-lg-8 col-md-12 offset-lg-2">
              <div
                className="pt-4 pt-md-0 animation animated fadeInRight"
                data-animation="fadeInRight"
                data-animation-delay="0.1s"
                style={{ animationDelay: '0.1s', opacity: 1 }}
              >
                <form method="post" name="enq" className="field_form">
                  <div className="row">
                    <div
                      className="form-group col-md-12 animation animated fadeInUp"
                      data-animation="fadeInUp"
                      data-animation-delay="0.4s"
                      style={{ animationDelay: '0.4s', opacity: 1 }}
                    >
                      <input
                        type="text"
                        required="required"
                        placeholder="Enter Name *"
                        id="first-name"
                        className="form-control"
                        name="name"
                      />
                    </div>
                    <div
                      className="form-group col-md-12 animation animated fadeInUp"
                      data-animation="fadeInUp"
                      data-animation-delay="0.6s"
                      style={{ animationDelay: '0.6s', opacity: 1 }}
                    >
                      <input
                        type="email"
                        required="required"
                        placeholder="Enter Email *"
                        id="email"
                        className="form-control"
                        name="email"
                      />
                    </div>
                    <div
                      className="form-group col-md-12 animation animated fadeInUp"
                      data-animation="fadeInUp"
                      data-animation-delay="0.8s"
                      style={{ animationDelay: '0.8s', opacity: 1 }}
                    >
                      <input
                        type="text"
                        required="required"
                        placeholder="Enter Subject"
                        id="subject"
                        className="form-control"
                        name="subject"
                      />
                    </div>
                    <div
                      className="form-group col-md-12 animation animated fadeInUp"
                      data-animation="fadeInUp"
                      data-animation-delay="1s"
                      style={{ animationDelay: '1s', opacity: 1 }}
                    >
                      <textarea
                        required="required"
                        placeholder="Message *"
                        id="description"
                        className="form-control"
                        name="message"
                        rows="2"
                      ></textarea>
                    </div>
                    <div
                      className="col-md-12 text-center animation animated fadeInUp"
                      data-animation="fadeInUp"
                      data-animation-delay="1.2s"
                      style={{ animationDelay: '1.2s', opacity: 1 }}
                    >
                      <button
                        type="submit"
                        title="Submit Your Message!"
                        className="btn btn-default btn-radius btn-block"
                        id="submitButton"
                        name="submit"
                        value="Submit"
                      >
                        Submit <i class="ion-ios-arrow-thin-right"></i>
                      </button>
                    </div>
                    <div className="col-md-12">
                      <div
                        id="alert-msg"
                        className="alert-msg text-center"
                      ></div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <div
          className="top_footer bg_light_dark"
          data-z-index="1"
          data-parallax="scroll"
          data-image-src="assets/images/footer_bg.png"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-12">
                <div
                  className="footer_logo mb-3 animation animated fadeInUp"
                  data-animation="fadeInUp"
                  data-animation-delay="0.2s"
                  style={{ animationDelay: '0.2s', opacity: 1 }}
                >
                  <a href="#home_section" className="page-scroll">
                    {/* <img
                      alt="logo"
                      src={Logo}
                      width={100}
                      height={100}
                    /> */}
                  </a>
                </div>
                <div className="footer_desc">
                  <p
                    className="animation animated fadeInUp"
                    data-animation="fadeInUp"
                    data-animation-delay="0.4s"
                    style={{ animationDelay: '0.4s', opacity: 1 }}
                  >
                    We are launching COFT, Coin On File Token to provide you the
                    best OTT platform, Gaming Platform & E-Commerce Platform
                    which will offers you a very unique, interactive &
                    profitable solution. Our token will be used on many
                    ecommerce platforms that are already on the Internet & you
                    will get huge discounts & offers when we shop using COFT.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 res_md_mt_30 res_sm_mt_20"></div>
              <div className="col-lg-5 col-md-6 res_md_mt_30 res_sm_mt_20">
                <div className="newsletter_form">
                  <h4
                    className="footer_title border_title animation animated fadeInUp"
                    data-animation="fadeInUp"
                    data-animation-delay="0.2s"
                    style={{ animationDelay: '0.2s', opacity: 1 }}
                  >
                    Newsletter
                  </h4>
                  <p
                    className="animation animated fadeInUp"
                    data-animation="fadeInUp"
                    data-animation-delay="0.4s"
                    style={{ animationDelay: '0.4s', opacity: 1 }}
                  >
                    By subscribing to our mailing list you will always be update
                    with the latest news from us.
                  </p>
                  <form
                    className="subscribe_form animation animated fadeInUp"
                    data-animation="fadeInUp"
                    data-animation-delay="0.4s"
                    style={{ animationDelay: '0.4s', opacity: 1 }}
                  >
                    <input
                      className="input-rounded"
                      type="text"
                      required=""
                      placeholder="Enter Email Address"
                    />
                    <button
                      type="submit"
                      title="Subscribe"
                      className="btn-info"
                      name="submit"
                      value="Submit"
                    >
                      {' '}
                      Subscribe{' '}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom_footer">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <p className="copyright">
                  Copyright © 2021 All Rights Reserved.
                </p>
              </div>
              <div className="col-md-6">
                <ul className="list_none footer_menu">
                  <li>
                    <a href="#">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="#">Terms &amp; Conditions</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default App
